import Image from "@/services/Image"

export default class UserImage {
    static handle(
        host,
        name,
        w = null,
        h = null,
    ) {
        if (host && name) {
            return Image.handle(host, name, w, h)
        } else {
            return UserImage.default()
        }
    }

    static default() {
        return "/assets/static/user/no_image.jpg"
    }
}
